import { isSuperAdmin } from '@/functions/auth';
import User from '@/models/User';

export const canAccessMultipleUnits = (user: User) =>
  isSuperAdmin(user.userType) || user.unitsIds.length > 1;
